import { useEffect } from "react"
import {
  useAsyncReplySubscription,
  ReplyCompletedUpdate,
  ReplyErrorUpdate,
  ReplyProgressUpdate,
} from "./useAsyncReplySubscription"

interface AsyncReplyHandlerProps {
  requestId: string
  onCompleted: (response: ReplyCompletedUpdate) => void
  onError: (error: ReplyErrorUpdate) => void
  onProgress?: (progress: ReplyProgressUpdate) => void
  onSubscribingChange?: (isSubscribing: boolean) => void
  timeout?: number
}

export function AsyncReplyHandler({
  requestId,
  onCompleted,
  onError,
  onProgress,
  onSubscribingChange,
  timeout,
}: AsyncReplyHandlerProps) {
  const { isSubscribing } = useAsyncReplySubscription({
    requestId,
    onCompleted,
    onError,
    onProgress,
    timeout,
  })

  useEffect(() => {
    onSubscribingChange?.(isSubscribing)
  }, [isSubscribing, onSubscribingChange])

  return null
}

